import { useCallback } from "react";
import { SchedulePreviewAppointment } from "@grow-therapy-team/seedling-components";
import { useSetAtom } from "jotai";
import { scheduledPatientInformationAtom } from "../schedule-preview/state";
import { useOpenClientInformationCallback } from "./useClientInformationDrawerCallbacks";

/**
 * Hook that provides a callback to open the client information drawer for a given appointment.
 * Sets the scheduled patient info and opens the drawer.
 */
export function useOpenClientInfoDrawerForAppointment() {
  const setScheduledPatientInfo = useSetAtom(scheduledPatientInformationAtom);
  const openClientInformation = useOpenClientInformationCallback();

  return useCallback(
    (appointment: SchedulePreviewAppointment["node"]) => {
      const patientShortId = appointment?.patient.shortId;
      const patientName = appointment?.patient.preferredFullName;

      setScheduledPatientInfo({
        name: patientName,
        patientShortId,
        appointmentType: appointment.appointmentType,
        appointmentStartTime: appointment.timeStart,
        appointmentEndTime: appointment.timeEnd,
        recurringAppointmentGrouping: appointment.recurringAppointmentGrouping,
        appointmentLocation: appointment.inOffice,
        appointmentId: appointment.id,
        appointmentShortId: appointment.appointmentShortId,
        patientId: appointment.patient.id,
        patientName,
        pronouns: appointment.patient?.pronouns,
        recurringAppointmentGroupingId:
          appointment?.recurringAppointmentGrouping
            ?.recurringAppointmentGroupingId,
        indefinite: appointment?.recurringAppointmentGrouping?.indefinite,
        start: appointment.time_start,
        end: appointment.time_end,
        virtual: appointment.virtual === "virtual",
        weeksBetween: appointment?.recurringAppointmentGrouping?.weeksBetween,
        numRecurrences:
          appointment?.recurringAppointmentGrouping?.appointments?.length,
        recurrenceRule:
          appointment?.recurringAppointmentGrouping?.recurrenceRule,
        version: appointment?.recurringAppointmentGrouping?.version,
      });

      openClientInformation({ patientShortId });
    },
    [setScheduledPatientInfo, openClientInformation],
  );
}
